import { TextField } from '@mui/material';
import { inputSlotProps, inputSx } from './NewRoundModeler.styles';
import { focusNextOnEnter } from './NewRoundModeler.utils';

interface InputCellProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

const InputCell = ({ value, onChange, placeholder }: InputCellProps) => (
  <TextField
    value={value}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
    variant="standard"
    slotProps={{ ...inputSlotProps, htmlInput: { ...inputSlotProps.htmlInput, onKeyDown: focusNextOnEnter } }}
    sx={inputSx}
  />
);

export default InputCell;
